// extracted by mini-css-extract-plugin
export var navigation = "navigation-module--navigation--3oAgM";
export var navigationPrev = "navigation-module--navigation-prev--1j_L_";
export var navigationNext = "navigation-module--navigation-next--3YBiS";
export var navigationArrow = "navigation-module--navigation-arrow--Gu82I";
export var navigationArrowPrev = "navigation-module--navigation-arrow--prev--2VPa9";
export var navigationArrowNext = "navigation-module--navigation-arrow--next--b7mpj";
export var navigationLink = "navigation-module--navigation-link--1uOcr";